export const FeatureName = 'superCustomers';
